import React from "react";
import styled, { keyframes } from "styled-components";
import { BsFacebook, BsInstagram } from "react-icons/bs";
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import { footerTextAnimation } from "animation";

function Footer() {
  const [element, controls] = useScroll();

  const currentYear = new Date().getFullYear();

  return (
    <Foot ref={element}>
      <motion.div
        className="footer-text"
        variants={footerTextAnimation}
        animate={controls}
        transition={{ delay: 0.02, type: "tween", duration: 0.8 }}
      >
        <span className="year">© {currentYear} Caddyshack City.</span>
        <span className="madeby">
          Made with ❤️ by{" "}
          <a
            href="https://www.miraelite.com/"
            className="neon-text"
            target="_blank"
            rel="noreferrer"
          >
            Mira Elite
          </a>{" "}
          &nbsp;since 2022
        </span>
      </motion.div>

      <motion.div
        className="footer__social__icons"
        variants={footerTextAnimation}
        animate={controls}
        transition={{ delay: 0.02, type: "tween", duration: 0.8 }}
      >
        <a
          href="https://www.facebook.com/caddyshackcity?mibextid=LQQJ4d"
          target="_blank"
          rel="noreferrer"
        >
          <BsFacebook />
        </a>
        <a
          href="https://www.instagram.com/caddyshackcity/?igshid=YmMyMTA2M2Y%3D"
          target="_blank"
          rel="noreferrer"
        >
          <BsInstagram />
        </a>
      </motion.div>
    </Foot>
  );
}

// 💜 Neon purple glow animation
const neonPulse = keyframes`
  0%, 100% {
    text-shadow:
      0 0 5px #b026ff,
      0 0 10px #b026ff,
      0 0 20px #b026ff,
      0 0 40px #c86bfa;
  }
  50% {
    text-shadow:
      0 0 3px #d794ff,
      0 0 8px #c86bfa,
      0 0 16px #b026ff,
      0 0 32px #a94eff;
  }
`;

const Foot = styled(motion.footer)`
  background-color: var(--primary-color);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5rem 10rem;

  .footer-text {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    font-size: 1rem;

    .neon-text {
      font-weight: 600;
      color: #d794ff;
      text-decoration: none;
      animation: ${neonPulse} 2s ease-in-out infinite;
      transition: all 0.3s ease;
    }
    .neon-text:hover {
      color: #fff;
      text-shadow: 0 0 5px #fff, 0 0 10px #d794ff, 0 0 20px #b026ff,
        0 0 40px #b026ff;
      transform: scale(1.05);
    }
  }

  .footer__social__icons {
    display: flex;
    gap: 2rem;
    a {
      font-size: 1.4rem;
      color: #fff;
      transition: 0.3s;
      &:hover {
        color: #b026ff;
        transform: scale(1.2);
        text-shadow: 0 0 10px #b026ff;
      }
    }
  }

  /* 📱 Mobile view: stack text on 2 lines */
  @media screen and (max-width: 768px) {
    padding: 2rem;
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;

    .footer-text {
      flex-direction: column;
      gap: 0.3rem;
      font-size: 0.9rem;

      .year {
        display: block;
      }
      .madeby {
        display: block;
      }
    }

    .footer__social__icons {
      gap: 1.5rem;
    }
  }
`;

export default Footer;
